import { render, unmountComponentAtNode } from "react-dom";
import * as React from "react";
export class RenderComponent {
    constructor(domId, Component, props) {
        this.isActive = false;
        this.domId = domId;
        this.component = Component;
        this.props = props;
        this.activate();
    }
    activate() {
        if (!this.isActive) {
            const domRef = document.getElementById(this.domId);
            if (domRef) {
                render(React.createElement(this.component, this.props), domRef);
                this.isActive = true;
            }
        }
        return this;
    }
    deactivate() {
        const domRef = document.getElementById(this.domId);
        if (domRef) {
            unmountComponentAtNode(domRef);
            this.isActive = false;
        }
        return this;
    }
}
//# sourceMappingURL=RenderComponent.js.map